import React from "react";
import { HRProvider } from "../HRContext";
import DepartmentList from "../departments/DepartmentList";

const DepartmentListWrapper: React.FC = () => {
  return (
    <HRProvider>
      <DepartmentList />
    </HRProvider>
  );
};

export default DepartmentListWrapper;
